import React, { memo } from 'react';

import { Title } from '@components/Title';
import { TextBlock } from '@components/TextBlock';

import { EEducationIcons } from '@enum';

import { CharacteristicLine } from './CharacteristicLine';

import {
  DCardContainer,
  DCInfoContainer,
  DegreeContainer,
  DescriptionContainer,
  DCCharacteristicContainer,
} from './DiplomaCard.styled';

import { DiplomaCardProps } from './DiplomaCard.types';

export const DiplomaCard = memo(
  ({
    grade,
    field,
    period,
    degree,
    program,
    description,
    background,
    blockShadow,
    titleReverse,
    elementShadow,
    backgroundReverse,
    textColor,
  }: DiplomaCardProps) => (
    <DCardContainer background={background} blockShadow={blockShadow}>
      <DegreeContainer
        elementShadow={elementShadow}
        backgroundReverse={backgroundReverse}
      >
        <Title text={degree} size={2} color={titleReverse} />
      </DegreeContainer>
      <DCInfoContainer>
        <DCCharacteristicContainer>
          <CharacteristicLine text={field} textColor={textColor} />
          <CharacteristicLine
            icon={EEducationIcons.program}
            text={program}
            textColor={textColor}
          />
          <CharacteristicLine
            icon={EEducationIcons.period}
            text={period}
            textColor={textColor}
          />
          <CharacteristicLine
            icon={EEducationIcons.grade}
            text={grade}
            textColor={textColor}
          />
        </DCCharacteristicContainer>
        <DescriptionContainer>
          <TextBlock
            align="left"
            text={description}
            indent={20}
            color={textColor}
          />
        </DescriptionContainer>
      </DCInfoContainer>
    </DCardContainer>
  ),
);
